import { useEffect, useState } from 'react';

export function BuyWithPrime({ sku }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const js = window.document.createElement('script');
      js.src = 'https://code.buywithprime.amazon.com/bwp.v1.js';
      js.type = 'text/javascript';
      js.async = true;
      js.fetchPriority = 'high';
      js.id = 'bwpScript';
      document.head.appendChild(js);
    }

    return () => {
      const frame = document.getElementById('bwpFrame');
      if (frame && frame.parentNode) {
        frame.parentNode.removeChild(frame);
      }
      const script = document.getElementById('bwpScript');
      if (script && script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  useEffect(() => {
    let attempts = 0;
    const timer = setInterval(() => {
      attempts++;
      if (attempts > 10) {
        clearInterval(timer);
        return;
      }
      if (
        typeof window.bwp === 'object' &&
        typeof window.bwp.updateWidget === 'function' &&
        sku &&
        document.querySelector('#amzn-buy-now')
      ) {
        clearInterval(timer);
        window.bwp.updateWidget(sku);
      }
    }, 500);
    return () => clearInterval(timer);
  }, [sku]);

  return (
    <div
      data-prime-widget-sku={sku}
      className="buy-with-prime-container m-auto w-full flex flex-col-reverse mb-6"
    >
      <div
        id="amzn-buy-now"
        data-site-id={
          process.env.NEXT_PUBLIC_AMAZON_BWP_SITE_ID || 'o3krsbin2k'
        }
        data-widget-id={
          process.env.NEXT_PUBLIC_AMAZON_BWP_WIDGET_ID ||
          'w-gfUDvYZJWj7eeyHQGn9uk6'
        }
        data-sku={sku}
      />
      <div className="or-separator">OR</div>
    </div>
  );
}
